import React from "react";
import { formatMessage } from "lib/globalize-util";
import { DialogTitle } from "containers/folders/containers/space-manager/components/manage-access/dialog-title";
import { nuOrderTheme as theme, AlertDialog } from "@nuorder/components";

interface IOwnProps {
    onOk: () => void;
    open: boolean;
    itemLimit: number;
    title?: string | JSX.Element;
    message?: string;
}

export const OverItemsLimitDialog: React.FunctionComponent<IOwnProps> = ({ open, itemLimit, onOk, title, message }) => {
    const defaultTitle = React.useMemo(
        () => (
            <DialogTitle
                iconName="alertCircle24"
                mainTitle={formatMessage("Limit Reached")}
                iconColor={theme.palette.errorBase}
            />
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [theme]
    );
    const defaultMessage = React.useMemo(
        () => formatMessage("You have reached the maximum number of |limit| items", { limit: itemLimit }),
        [itemLimit]
    );
    return (
        <AlertDialog
            okLabel={formatMessage("Ok")}
            closeButtonAriaLabel={formatMessage("Close")}
            width={420}
            open={open}
            onOk={onOk}
            title={title || defaultTitle}
            message={message || defaultMessage}
        />
    );
};
